export const caseStatuses = [
  { label: "TRIAGE", value: "TRIAGE" },
  { label: "PENDING", value: "PENDING" },
  { label: "WORKING", value: "WORKING" },
  { label: "CANCELLED", value: "CANCELLED" },
  { label: "CLOSED", value: "CLOSED" },
  { label: "NEW", value: "NEW" },
]
